module.exports = __webpack_public_path__ + "img/first_name.3fe3d5a4.svg";